export const legalForm = "LegalForm";
export const assetConditionType = "AssetConditionType";
export const gender = "Gender";
